<template>
    <address>
    <h5>Address {{ label }}:</h5>
    <div>{{ address.road }} {{ address.zipCode }} {{ address.city }}
        <template v-if="address.complement">&nbsp{{ address.complement }}</template>
        <template v-if="address.country">&nbsp{{ address.country }}</template>
        <template v-if="address.state">&nbsp{{ address.state }}</template>
    </div>
      <button type="button" class="btn btn-primary m-1" @click="$emit('edit')">EDIT</button>
      <button type="button" class="btn btn-primary m-1" @click="$emit('search')">SEARCH</button>
    </address>
</template>

<script>
export default {
  props: {
    address: {
      type: Object,
      default: () => ({}),
      validator (value) {
        const dict = ['road', 'zipCode']
        let allPropertiesDefined = true
        dict.forEach(currentProperty => {
          if (!value[currentProperty]) {
            allPropertiesDefined = false
          }
        })
        return allPropertiesDefined
      }
    },
    label: String
  }
}
</script>
